// extracted by mini-css-extract-plugin
export default {"thumb":"q8hco6m9","activeThumb":"DrtWrufO","wrapper":"TGkPvzf0","wrapperLeft":"w5Xvks3j","container":"uwcyGwKN","lastThumb":"RTiAlgsV"};